export default "__VITE_ASSET__a8986a4c__"